import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--discount-toggle"
// Handles the discount toggle switch and communicates with discount controller via outlet
export default class extends Controller {
  static outlets = ["documents--discount"]

  toggle(event) {
    if (this.hasDocumentsDiscountOutlet) {
      if (event.target.checked) {
        this.documentsDiscountOutlet.show()
      } else {
        this.documentsDiscountOutlet.hide()
      }
    }
  }
}
